/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from "react"
import ReactDOM from "react-dom"
import {
 Modal, Input, Button, Checkbox, message 
} from "antd"
import PropTypes from "prop-types"
import SmsCodeVerify from "@/components/rc-sms-verify"
import ImgVerify from "@/components/rc-img-verify"
import {
  $cookie,
  isPhone,
  isCode,
  isNumberInput,
  sessionstorage,
  getSuccessMsg
} from "$utils"
import { UseIntentOrderExt } from "../order-ext"
import { UseModalSuccess } from "../success"
import { intentBargain } from "../service"
import "./styles.scss"
import $dom from "../util"

// 砍价弹窗
const IntentBargain = (props) => {
  const { onClose, submitParams, otherParams } = props
  const [visible, setVisible] = useState(props.visible)
  const [priceTo, setPriceTo] = useState(submitParams.price) // 砍价金额
  const [phone, setPhone] = useState(
    $cookie.get("rrc_login_phone") || sessionstorage.get("intentPhone") || ""
  )
  const [errMsg, setErrMsg] = useState()
  const [noteChecked, setNoteChecked] = useState(true)
  const [title, setTitle] = useState("")
  const priceToRef = useRef()

  // 图形验证码
  const [imgVerify, setImgVerify] = useState(false)
  const [imgVerifyCode, setImgVerifyCode] = useState(false)

  // 短信验证码
  const [smsVerify, setSmsVerify] = useState(false)
  const [smsVerifyCode, setSmsVerifyCode] = useState(true)

  const { basicInfo } = otherParams
  useEffect(() => {
    if (Number(priceTo) > Number(submitParams.owner_price)) {
      setErrMsg("出价已经高于原价啦")
    } else {
      setErrMsg("")
    }
  }, [priceTo])
  const closeModal = () => {
    global.$rbl.push({
      event: "car-detail_top-button-bargainpopup_close",
      content: {
        param: `car_id_${basicInfo.car_id}`
      }
    })
    setVisible(false)
    onClose && onClose()
  }
  // 砍价线索提交
  const bargainSubmit = async (isrefresh) => {
    const _isrefresh = isrefresh && isrefresh === true
    if (!_isrefresh) {
      global.$rbl.push(submitParams.submit_sources)
      global.$rbl.push({
        event: "car-detail_top-button-bargainpopup_submit",
        content: {
          param: `car_id_${basicInfo.car_id}`
        }
      })
    }
    setErrMsg("")
    if (!Number(priceTo)) {
      setErrMsg("请输入砍价金额")
      priceToRef.current?.focus()
      return
    }
    if (Number(priceTo) > Number(submitParams.owner_price)) {
      setErrMsg("出价已经高于原价啦")
      return
    }
    if (!isPhone(phone)) {
      setErrMsg("手机号输入有误")
      return
    }
    if (!_isrefresh && imgVerify && imgVerifyCode && !isCode(imgVerifyCode)) {
      setErrMsg("图形验证码输入有误")
      return
    }
    if (smsVerify === true && (!smsVerifyCode || !isCode(smsVerifyCode))) {
      setErrMsg("短信验证码输入有误")
      return
    }
    const params = {
      ...submitParams,
      price: `${priceTo}`,
      phone,
      model_name: "bargain"
    }
    // 图形验证码参数
    if (imgVerify && imgVerifyCode && isCode(imgVerifyCode)) {
      params.verify_code = imgVerifyCode
    }
    // 短信验证码参数
    if (smsVerify && smsVerifyCode && isCode(smsVerifyCode)) {
      params.verification_code = smsVerifyCode
    }
    try {
      const result = await intentBargain(params)
      $dom.popLayerSubmit()
      if (result.data.display_next_page === true) {
        const nextSubmitParams = {
          ...submitParams,
          phone,
          price: `${priceTo}`,
          sub_product: "bargain",
          model_name: "bargain"
        }
        new UseIntentOrderExt({
          isSmsVerify: smsVerify,
          modelName: "discount_notify",
          submitParams: nextSubmitParams,
          otherParams,
          profile: result.data.profile
        }).open()
      } else {
        const showSuccess = () => {
          new UseModalSuccess({
            msg: result.data.notice_message || getSuccessMsg("bargain")
          }).open()
        }
        // 未登录提交信息补充后，应该弹出登录弹窗，并发送短信验证码
        if (
          !smsVerify &&
          !$cookie.get("rrc_login_phone") &&
          !$cookie.get("rrc_login_token")
        ) {
          sessionstorage.set("loginBackModalInfo", {
            msg: result.data.notice_message || getSuccessMsg("bargain")
          })
          window.location.href = `${
            window.location.origin
          }/login?source=${encodeURIComponent(
            window.location.href
          )}&phone=${phone}`
          // new UseLogin({
          //   isAutoMsg: false,
          //   isAutoLogin: true,
          //   phone,
          //   onSuccessCallBack: () => {
          //     showSuccess()
          //   }
          // }).open()
        } else {
          showSuccess()
        }
      }
      global.$rbl.push(`${submitParams.submit_sources}-提交成功`)
      closeModal()
      setTitle("")
      setImgVerify("")
    } catch (error) {
      setTitle("")
      if (error.status === 200) {
        const result = error.data
        if (result.status === 100) {
          setImgVerify("")
          setErrMsg("")
          setTitle(result.data.notice_message)
        } else if (result.status === 400) {
          global.$rbl.push({
            event: "m_verification_show",
            content: { param: "verification" }
          })
          setImgVerify(result.image)
        } else if (result.status === 1000) {
          // 短信验证码
          setSmsVerify(true)
        } else if (result.status === 1001) {
          // 短信验证码
          setErrMsg("短信验证码输入有误")
        } else {
          message.error(result?.err_msg || result?.errMsg || "未知错误")
        }
      }
    }
  }
  return (
    <Modal
      bodyStyle={{ padding: "0px" }}
      style={{ minWidth: "520px" }}
      centered
      visible={visible}
      footer={null}
      onCancel={() => {
        closeModal()
      }}
    >
      <div className="r-intent-bargain">
        <div className="logo">
          <span className="dollar">¥</span>
        </div>
        <h2 className="title">
          {title ? "您出价有点低哦" : "请输入您的期望价格"}
        </h2>
        <p className="msg">
          {title ? (
            <span dangerouslySetInnerHTML={{ __html: title }} />
          ) : (
            <>
              卖家报价:
              <span className="price">
                {Number(submitParams.owner_price).toFixed(2)}万
              </span>
            </>
          )}
        </p>
        <Input
          ref={priceToRef}
          className="priceTo"
          placeholder="期望价格"
          suffix="万"
          size="large"
          value={priceTo}
          onClick={() => {
            global.$rbl.push("car-detail_top-button-bargainpopup_inputbox")
          }}
          onInput={(e) => {
            if (isNumberInput(e.target.value)) {
              setPriceTo(e.target.value)
            }
          }}
        />
        <Input
          onClick={() => {
            global.$rbl.push("car-detail_top-button-bargainpopup_mobile")
          }}
          size="large"
          className="phone"
          placeholder="请输入您的手机号"
          maxLength={11}
          suffix={<i className="iconfont icon-shouji" />}
          value={phone}
          onChange={(e) => {
            setPhone(e.target.value)
          }}
        />
        {/* 防刷图形验证码 */}
        <ImgVerify
          className="image-verify"
          imgVerify={imgVerify}
          onImgVerifyCode={(code) => {
            setImgVerifyCode(code)
          }}
          onRefresh={() => {
            bargainSubmit(true)
          }}
        />
        {/* 防刷短信验证码 */}
        <SmsCodeVerify
          autoSend
          phone={phone}
          smsVerify={smsVerify}
          onErrMsg={(err) => {
            setErrMsg(err)
          }}
          onSmsCode={(code) => {
            setSmsVerifyCode(code)
          }}
        />
        <p className="err-msg">{errMsg}</p>
        <Button
          data-click="car-detail_top-button-bargainpopup_submit"
          size="large"
          type="primary"
          block
          className="submit"
          disabled={!noteChecked}
          onClick={bargainSubmit}
        >
          提交
        </Button>
        <div className="tip clearfix">
          <Checkbox
            className="check"
            checked={noteChecked}
            onChange={(e) => {
              setNoteChecked(e.target.checked)
            }}
          />
          <p className="txt">
            阅读并同意
            <a
              href="https://sta.renrenche.com/legal/terms.html"
              target="_blank"
              onClick={() => {
                closeModal()
              }}
            >
              《用户服务协议》
            </a>
            、
            <a
              href="https://sta.renrenche.com/legal/privacy.html"
              target="_blank"
              onClick={() => {
                closeModal()
              }}
            >
              《隐私政策》
            </a>
            提交并注册为用户。
          </p>
        </div>
      </div>
    </Modal>
  )
}

IntentBargain.propTypes = {
  onClose: PropTypes.func, // 组件的关闭方法
  visible: PropTypes.bool,
  submitParams: PropTypes.object,
  otherParams: PropTypes.object
}

IntentBargain.defaultProps = {
  onClose: null,
  visible: false,
  submitParams: null,
  otherParams: null
}

function mountAnywhere(Comp, root) {
  const div = document.createElement("div");
  (root || document.body).appendChild(div)

  // 向组件注入 onClose 方法，以便组件能调用关闭
  const Clone = React.cloneElement(Comp, {
    onClose: () => {
      ReactDOM.unmountComponentAtNode(div)
      div.parentNode.removeChild(div)
    }
  })
  ReactDOM.render(Clone, div)

  return div
}

export class UseIntentBargain {
  constructor(params) {
    this.visible = false
    this.ref = null
    this.submitParams = params.submitParams
    this.otherParams = params.otherParams
  }

  open() {
    this.visible = true
    this.ref = mountAnywhere(
      <IntentBargain
        visible={this.visible}
        submitParams={this.submitParams}
        otherParams={this.otherParams}
      />
    )
    return this.ref
  }

  close() {
    this.visible = false
  }
}
export default IntentBargain
